import { fetchAPI } from '../utils/api';

export const getPendingSupplierPaymentCount = () => {
  return async dispatch => {
    try {
      const resp = await fetchAPI('supplier-payments/all', {
        method: 'POST',
        version: '2.0',
        payload: {
          page: 1,
          per_page: 1,
          q: '',
          filters: {
            status: ['PENDING'],
          },
        },
      });

      return dispatch({
        type: 'SET_NOTIFICATION_PENDING_SUPPLIER_PAYMENT',
        payload: resp.pagination?.total || 0,
      });
    } catch (error) {
      return dispatch({
        type: 'SET_NOTIFICATION_PENDING_SUPPLIER_PAYMENT',
        payload: 0,
      });
    }
  };
};

export const setNotificationCount = (payload: {
  supplier_payment?: number;
}) => {
  return dispatch => {
    return dispatch({
      type: 'SET_NOTFICATION_COUNT',
      payload,
    });
  };
};

export const getNotifications = (
  page = 1,
  perPage = 20,
  unreadOnly = false
) => {
  return async dispatch => {
    dispatch({ type: 'SET_NOTIFICATIONS_LOADING' });
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        per_page: perPage.toString(),
        unread_only: unreadOnly.toString(),
      });
      const resp = await fetchAPI(`notifications?${params}`, { method: 'GET' });
      // note: backend response.ok envelope ({ok: {items, total}}) vs flat; accept both
      const data = resp?.ok || resp || {};
      return dispatch({
        type: 'SET_NOTIFICATIONS',
        payload: {
          notifications: data.items || [],
          total: data.total || 0,
        },
      });
    } catch (error) {
      return dispatch({
        type: 'SET_NOTIFICATIONS',
        payload: { notifications: [], total: 0 },
      });
    }
  };
};

export const getUnreadCount = () => {
  return async dispatch => {
    try {
      const resp = await fetchAPI('notifications/unread-count', {
        method: 'GET',
      });
      const data = resp?.ok || resp || {};
      return dispatch({
        type: 'SET_NOTIFICATION_UNREAD_COUNT',
        payload: { count: data.count || 0 },
      });
    } catch (error) {
      return dispatch({
        type: 'SET_NOTIFICATION_UNREAD_COUNT',
        payload: { count: 0 },
      });
    }
  };
};

export const markAsRead = (id: number) => {
  return async dispatch => {
    try {
      await fetchAPI(`notifications/${id}/read`, { method: 'PUT' });
      return dispatch({
        type: 'UPDATE_NOTIFICATION',
        payload: { id, is_read: true, read_at: new Date().toISOString() },
      });
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
    }
  };
};

export const markAllAsRead = () => {
  return async dispatch => {
    try {
      await fetchAPI('notifications/read-all', { method: 'PUT' });
      await dispatch(getUnreadCount());
      return dispatch(getNotifications());
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
    }
  };
};

export const deleteNotification = (id: number) => {
  return async dispatch => {
    try {
      await fetchAPI(`notifications/${id}`, { method: 'DELETE' });
      return dispatch({ type: 'DELETE_NOTIFICATION', payload: { id } });
    } catch (error) {
      console.error('Failed to delete notification:', error);
    }
  };
};

export const bulkDeleteNotifications = (ids: number[]) => {
  return async dispatch => {
    await fetchAPI('notifications', { method: 'DELETE', payload: { ids } });
    ids.forEach(id =>
      dispatch({ type: 'DELETE_NOTIFICATION', payload: { id } })
    );
  };
};

export const deleteAllReadNotifications = () => {
  return async dispatch => {
    const result = await fetchAPI('notifications', {
      method: 'DELETE',
      payload: { delete_all_read: true },
    });
    if (result?.success) {
      dispatch({ type: 'DELETE_ALL_READ_NOTIFICATIONS' });
    }
  };
};

export const getNotificationPreferences = () => {
  return async dispatch => {
    try {
      const resp = await fetchAPI('notifications/preferences', {
        method: 'GET',
      });
      return dispatch({
        type: 'SET_NOTIFICATION_PREFERENCES',
        payload: resp?.ok || resp || {},
      });
    } catch (error) {
      return dispatch({ type: 'SET_NOTIFICATION_PREFERENCES', payload: {} });
    }
  };
};

export const updateNotificationPreferences = (
  preferences: Record<string, { is_enabled: boolean }>
) => {
  return async dispatch => {
    try {
      await fetchAPI('notifications/preferences', {
        method: 'PUT',
        payload: preferences,
      });
      return dispatch({
        type: 'SET_NOTIFICATION_PREFERENCES',
        payload: preferences,
      });
    } catch (error) {
      console.error('Failed to update notification preferences:', error);
    }
  };
};
